module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-base-shadow-2.121f6602.png";